
import Vue from 'vue'
import DashboardPlugin from './material-dashboard'

// general app
import App from './App.vue'

import store from './store';

// router and multilenguage setup
import router from './routes'

import Chartist from 'chartist'

import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import VueAnalytics from 'vue-analytics';
import CustomIcon from "@/components/CustomIcon.vue";
// plugin setup
Vue.use(DashboardPlugin)
Vue.component('v-chart', ECharts)
Vue.component('CustomIcon', CustomIcon);

Vue.use(VueAnalytics, {
  id: 'UA-153575146-1',
  router
});


// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
  get () {
    return this.$root.Chartist
  }
})

/* eslint-disable no-new */

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  data: {
    Chartist: Chartist
  }
  //store
})
